import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { t } from "../../i18n";
import type { DevelopmentSelection } from "../chat/ChatDevelopmentPanel.types";
import { useWorkspaceDialogFocus } from "../workspace-editor/useWorkspaceDialogFocus";
import { FileTab } from "./FileTab";

export function GitDiffDialog({
  conversationId,
  selection,
  path,
  onClose,
}: {
  conversationId: string;
  selection: DevelopmentSelection;
  path: string;
  onClose: () => void;
}) {
  const ref = useWorkspaceDialogFocus({ onClose });
  return createPortal(
    <div
      className="fixed inset-0 z-[80] grid place-items-center bg-black/50 p-4"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        ref={ref}
        role="dialog"
        aria-modal="true"
        aria-label={t("Compare with HEAD")}
        className="flex h-[80vh] w-full max-w-5xl min-w-0 flex-col overflow-hidden rounded-xl border border-stone-200 bg-white shadow-2xl dark:border-white/10 dark:bg-stone-900"
      >
        <div className="flex shrink-0 items-center gap-2 border-b border-stone-200 px-3 py-2 text-xs dark:border-white/10">
          <span className="min-w-0 flex-1 truncate">
            {t("Compare with HEAD")} ·{" "}
            {t("Working tree including staged changes")}
          </span>
          <button
            className="button p-2"
            aria-label={t("Close")}
            onClick={onClose}
          >
            <X size={16} />
          </button>
        </div>
        <div className="min-h-0 flex-1">
          <FileTab
            conversationId={conversationId}
            selection={selection}
            path={path}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}
